<template>
    <modal-live ref="modal" :default-show-modal="false" :dismiss-on-overlay="false">
        <div class="modal-header pb-0">
            <h3 class="headline--modal">Share</h3>
            <span class="modal__icon-close" @click="close()">
                <svg>
                    <use :xlink:href="`${icons['close']}#icon`"></use>
                </svg>
            </span>
        </div>
        <div class="dialog share pt-0">
            <p>Share direction from your starting point to your destination</p>
            <div class="input-text__wrapper d-flex align-items-center">
                <input
                    :value="link"
                    type="text"
                    readonly
                    autocomplete="chrome-off"
                    class="flex-fill"
                    id="share-link-input"
                />
                <div class="cursor-pointer" @click="copyLink">
                    <span v-if="!copied" class="color--orange">
                        COPY LINK
                    </span>
                    <span v-else class="text-success"> COPIED </span>
                </div>
            </div>
        </div>
    </modal-live>
</template>
<script>
export default {
    props: ['link'],
    data() {
        return {
            icons: window.here.icons,
            copied: false,
        };
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        close() {
            this.$refs.modal.close();
        },
        dismiss() {
            this.$refs.modal.dismiss();
        },
        copyLink() {
            const copyText = document.querySelector('#share-link-input');
            copyText.select();
            document.execCommand('copy');
            document.getSelection().removeAllRanges();
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 800);

            this.$gtag.event('PLAN_SHARE_COPY', {
                event_category: 'PLAN',
            });
        },
    },
};
</script>
<style lang="scss">
.dialog.share {
    padding-left: 35px;
    padding-right: 35px;
    color: #4e3a30;
    font-size: 16px;
    font-weight: 500;

    .input-text__wrapper {
        border: 1px solid #bcb4b0;
        border-radius: 4px;
        overflow: hidden;
        height: 40px;
        padding-left: 12px;
        padding-right: 12px;
        position: relative;

        input {
            height: 40px;
            border: 0;
            padding: 0;
            font-weight: 500;
            color: #bcb4b0;

            &:focus {
                outline: 0;
            }
        }
    }

    .cursor-pointer {
        cursor: pointer;
    }
}
</style>
